module.exports = __webpack_public_path__ + "assets/img/thumb-Blue-Microphones-Landing-Page.b9932f31.jpg";